import { render, staticRenderFns } from "./SurveyQuestionModal.vue?vue&type=template&id=496c240b&scoped=true&"
import script from "./SurveyQuestionModal.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestionModal.vue?vue&type=style&index=0&id=496c240b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c240b",
  null
  
)

export default component.exports